import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";
import EventToken from "@jumbo/Dashboards/EventToken";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.eventTokenList"} />, isActive: true },
];

const EventTokenList = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.eventTokenList" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.eventTokenList.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <EventToken />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default EventTokenList;
